/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { connect } from 'react-redux';

import { Banner } from './index';
import { IApplicationState } from '../../types/store';

export interface IOwnBannerProps {
  key: string;
  className?: string;
  placement: 'footer';
}

export interface IStateBannerProps {
  regionId?: number;
  userIsAgent?: boolean;
  selectedStations: number[];
  selectedRoads: number[];
}

export function mapStateToProps(state: IApplicationState): IStateBannerProps {
  const {
    userData: { user },
    filters,
    stations,
    roads,
  } = state;

  return {
    regionId: filters.regionId!,
    userIsAgent: user && !!user.isAuthenticated && !!user.isAgent,
    selectedStations: stations.selectedStations,
    selectedRoads: roads.selectedRoads,
  };
}

export const AdFoxBannerContainer = connect<IStateBannerProps, null, IOwnBannerProps>(mapStateToProps)(Banner);
